import { ComponentProps } from "react";
import { Flex } from "antd";

import { Logo } from "@components/Logo";

import { LogoWrapper } from "./styles";

export const AuthLogo = (props: ComponentProps<"div">) => {
  return (
    <Flex justify="center">
      <LogoWrapper {...props}>
        <Logo />
      </LogoWrapper>
    </Flex>
  );
};
